import { c as _c } from "react/compiler-runtime";
import { type StructuredHeader } from '@/components/Header/utils';
import { TdsNextLink } from '@/components/Link/TdsLink';
import RichText from '@/components/RichText';
import { DASHBOARD_PATH } from '@/constants';
import { isMedia } from '@/payload/lib/isMedia';
import { Drawer, DrawerContent, DrawerDescription, DrawerHeader, DrawerNested, DrawerTitle } from '@tallinn-arvudes/ui/atoms/drawer';
import { ArrowIcon } from '@tallinn-arvudes/ui/atoms/icons/arrow-icon';
import { CloseIcon } from '@tallinn-arvudes/ui/atoms/icons/close-icon';
import { ScrollArea } from '@tallinn-arvudes/ui/atoms/scroll-area';
import { KEY_EVENT_KEYS } from '@tallinn-arvudes/ui/constants';
import { useLockDocumentScroll } from '@tallinn-arvudes/ui/hooks';
import { Button } from '@tallinn-arvudes/ui/tallinn-design/Button';
import { cn } from '@tallinn-arvudes/ui/utils';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import React, { useEffect, useState, type DetailedHTMLProps, type HTMLAttributes } from 'react';
export const MobileNav = t0 => {
  const $ = _c(57);
  const {
    openKey,
    data,
    open,
    setOpen
  } = t0;
  const [activeLinkData, setActiveLinkData] = useState(null);
  const router = useRouter();
  useLockDocumentScroll(open);
  let t1;
  let t2;
  if ($[0] !== open) {
    t1 = () => {
      if (typeof window !== "undefined" && open) {
        window.scrollTo(0, 0);
      }
      setActiveLinkData(null);
    };
    t2 = [open];
    $[0] = open;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = link => {
      setActiveLinkData(link);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onNavItemClick = t3;
  let t4;
  let t5;
  if ($[4] !== data.navLinks || $[5] !== openKey) {
    t4 = () => {
      if (data.navLinks && openKey) {
        const activeNavLink = data.navLinks.find(link_0 => link_0.key === openKey);
        if (activeNavLink) {
          setActiveLinkData(activeNavLink);
        }
      }
    };
    t5 = [openKey, data.navLinks];
    $[4] = data.navLinks;
    $[5] = openKey;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== router || $[9] !== setOpen) {
    t6 = () => {
      setOpen(false);
      router.push(DASHBOARD_PATH);
    };
    $[8] = router;
    $[9] = setOpen;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleNavigation = t6;
  let t7;
  if ($[11] !== setOpen) {
    t7 = () => {
      setOpen(false);
    };
    $[11] = setOpen;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <DrawerTitle className="sr-only">Mobiili menüü</DrawerTitle>;
    t9 = <DrawerDescription className="sr-only">Menüü kategooriate list</DrawerDescription>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t8 = $[13];
    t9 = $[14];
  }
  let t10;
  if ($[15] !== setOpen) {
    t10 = () => {
      setOpen(false);
      setActiveLinkData(null);
    };
    $[15] = setOpen;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <CloseIcon />;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10) {
    t12 = <DrawerHeader className="p-0 flex">{t8}{t9}<Button variant="icon" onClick={t10} aria-label={"Sulge k\xFClgmen\xFC\xFC"} className="text-white mr-5 my-5 ml-auto inline-flex items-center justify-center">{t11}</Button></DrawerHeader>;
    $[18] = t10;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => {
      setActiveLinkData(null);
    };
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = !!activeLinkData;
  let t15;
  let t16;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <DrawerTitle className="sr-only">Mobiili menüü</DrawerTitle>;
    t16 = <DrawerDescription className="sr-only">Menüü kategooriate alamkategooriate list</DrawerDescription>;
    $[21] = t15;
    $[22] = t16;
  } else {
    t15 = $[21];
    t16 = $[22];
  }
  let t17;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <DrawerHeader className="p-5 pl-0 flex">{t15}{t16}<Button compact={true} className="flex items-center h-auto bg-nav-foreground" onClick={() => {
        setActiveLinkData(null);
      }} icon={<ArrowIcon className="!h-3 !w-3 rotate-180" />} iconPosition="left">Tagasi</Button></DrawerHeader>;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== activeLinkData || $[25] !== setOpen) {
    t18 = activeLinkData?.linkGroup && activeLinkData.linkGroup.map((linkGroup, index) => {
      if (!linkGroup) {
        return null;
      }
      const {
        id,
        links,
        link: link_1
      } = linkGroup;
      if (link_1.href) {
        return <div key={`group-${id}-${index}`} className="border-b-0 p-1"><TdsNextLink noUnderline={link_1.type !== "custom"} external={link_1.newTab} light={true} className="font-bold px-1 justify-start" href={link_1.href} key={`link-${id}-${index}`} onClick={() => {
            setActiveLinkData(null);
            setOpen(false);
          }} scroll={link_1.scroll}>{link_1.name}</TdsNextLink><div className="m-1 ml-4 flex flex-col">{links.map(link_2 => {
              if (!link_2.href) {
                return null;
              }
              return <TdsNextLink noUnderline={link_2.type !== "custom"} external={link_2.newTab} light={true} href={link_2.href} key={`link-${link_2.id}-${index}`} onClick={() => {
                setActiveLinkData(null);
                setOpen(false);
              }} scroll={link_2.scroll}>{link_2.name}</TdsNextLink>;
            })}</div></div>;
      }
      return <div key={`group-${id}-${index}`} className="border-b-0 p-1"><span className="font-bold px-1 justify-start tds-link !no-underline cursor-default tds-link--inline !text-neutral-0">{link_1.name}</span><div className="m-1 ml-4 flex flex-col">{links.map(link_3 => {
            if (!link_3.href) {
              return null;
            }
            return <TdsNextLink noUnderline={link_3.type !== "custom"} external={link_3.newTab} light={true} href={link_3.href} key={`link-${link_3.id}-${index}`} onClick={() => {
              setActiveLinkData(null);
              setOpen(false);
            }} scroll={link_3.scroll}>{link_3.name}</TdsNextLink>;
          })}</div></div>;
    });
    $[24] = activeLinkData;
    $[25] = setOpen;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t18) {
    t19 = <DrawerContent className="top-0 left-[20%] md:left-[60%] lg:left-[70%] bg-nav-foreground pl-5 pr-2">{t17}<ScrollArea className="relative h-full text-white"><div className="w-full space-y-1">{t18}</div></ScrollArea></DrawerContent>;
    $[27] = t18;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t14 || $[30] !== t19) {
    t20 = <DrawerNested handleOnly={true} onClose={t13} autoFocus={true} open={t14} direction="right">{t19}</DrawerNested>;
    $[29] = t14;
    $[30] = t19;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== data.navLinks) {
    let t22;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = link_4 => <MobileNavItem key={link_4.id} onClick={() => onNavItemClick(link_4)} data={link_4} />;
      $[34] = t22;
    } else {
      t22 = $[34];
    }
    t21 = data.navLinks.map(t22);
    $[32] = data.navLinks;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  const t22 = data.dashboardLinkTitle || "Minu t\xF6\xF6laud";
  let t23;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = [];
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== data.dashboardLinkDescription || $[37] !== data.dashboardLogo || $[38] !== t22) {
    t24 = {
      id: "dashboard",
      label: t22,
      description: data.dashboardLinkDescription,
      logo: data.dashboardLogo,
      linkGroup: t23
    };
    $[36] = data.dashboardLinkDescription;
    $[37] = data.dashboardLogo;
    $[38] = t22;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== handleNavigation) {
    t25 = e => {
      if (e.key === KEY_EVENT_KEYS.ENTER || e.key === KEY_EVENT_KEYS.SPACE) {
        handleNavigation();
      }
    };
    $[40] = handleNavigation;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== handleNavigation || $[43] !== t24 || $[44] !== t25) {
    t26 = <MobileNavItem data={t24} onKeyDown={t25} onClick={handleNavigation} />;
    $[42] = handleNavigation;
    $[43] = t24;
    $[44] = t25;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== t21 || $[47] !== t26) {
    t27 = <ScrollArea className="h-full p-1 pr-3 space-y-1 text-white pt-0"><div className="p-1 space-y-1 text-white">{t21}{t26}</div></ScrollArea>;
    $[46] = t21;
    $[47] = t26;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== t12 || $[50] !== t20 || $[51] !== t27) {
    t28 = <DrawerContent className="top-0 left-[10%] md:left-1/4 lg:left-1/2 bg-nav-foreground">{t12}{t20}{t27}</DrawerContent>;
    $[49] = t12;
    $[50] = t20;
    $[51] = t27;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] !== open || $[54] !== t28 || $[55] !== t7) {
    t29 = <Drawer onClose={t7} autoFocus={true} open={open} direction="right">{t28}</Drawer>;
    $[53] = open;
    $[54] = t28;
    $[55] = t7;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  return t29;
};
interface MobileNavItemProps extends DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  data: StructuredHeader['navLinks'][number];
  onClick: () => void;
}
export const MobileNavItem = t0 => {
  const $ = _c(40);
  let data;
  let onClick;
  let other;
  if ($[0] !== t0) {
    ({
      data,
      onClick,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = data;
    $[2] = onClick;
    $[3] = other;
  } else {
    data = $[1];
    onClick = $[2];
    other = $[3];
  }
  let T0;
  let media;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[4] !== data.logo || $[5] !== onClick || $[6] !== other) {
    media = isMedia(data.logo);
    T0 = Button;
    t3 = "flex h-auto w-full p-4 bg-nav-foreground";
    t4 = onClick;
    t5 = other;
    t2 = "w-full flex flex-nowrap flex-row gap-4";
    t1 = cn("relative shrink-0 w-12 md:w-16", {
      "h-12 md:h-16": media?.url
    });
    $[4] = data.logo;
    $[5] = onClick;
    $[6] = other;
    $[7] = T0;
    $[8] = media;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    T0 = $[7];
    media = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
  }
  let t6;
  if ($[14] !== media?.alt || $[15] !== media?.url) {
    t6 = media?.url && <Image src={media?.url} alt={media?.alt ?? ""} fill={true} style={{
      objectFit: "contain"
    }} />;
    $[14] = media?.alt;
    $[15] = media?.url;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t1 || $[18] !== t6) {
    t7 = <div className={t1}>{t6}</div>;
    $[17] = t1;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== data.label) {
    t8 = <h2 className="text-lg">{data.label}</h2>;
    $[20] = data.label;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ArrowIcon className="ml-2 !h-3 !w-3 shrink-0" />;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8) {
    t10 = <div className="flex flex-row flex-nowrap items-center">{t8}{t9}</div>;
    $[23] = t8;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== data.description) {
    t11 = !!data.description && <RichText data={data.description} className="font-normal" />;
    $[25] = data.description;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11) {
    t12 = <div className="flex flex-col gap-2 items-baseline text-left leading-5">{t10}{t11}</div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12 || $[31] !== t2 || $[32] !== t7) {
    t13 = <div className={t2}>{t7}{t12}</div>;
    $[30] = t12;
    $[31] = t2;
    $[32] = t7;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== T0 || $[35] !== t13 || $[36] !== t3 || $[37] !== t4 || $[38] !== t5) {
    t14 = <T0 className={t3} onClick={t4} {...t5}>{t13}</T0>;
    $[34] = T0;
    $[35] = t13;
    $[36] = t3;
    $[37] = t4;
    $[38] = t5;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
};